let $popup = $('.popup')
let $body = $('body')
let $html = $('html')

function closePopup()
{
  $popup.removeClass('popup-visible').removeAttr('data-rank-color')
  $html.removeClass('popup-open')
  $popup.find('.js-popup-content').html('')
}

function openPopup(popupLink)
{
  let popupContent = popupLink.attr('data-js-open-popup-methodology-content')
  let popupType = popupLink.attr('data-popup-type')
  let popupRankColor = popupLink.attr('data-ranking-color')
  let $popupContentHTML = $('[data-popup-content="'+popupContent+'"]').html()

  if($popupContentHTML && $popupContentHTML.length) {
    $popup.find('.js-popup-content').html($popupContentHTML)
    $popup.attr('data-content', popupType).attr('data-rank-color', popupRankColor)
    $popup.addClass('popup-visible')
    $html.addClass('popup-open')
  }

}

$body.on('click', '[data-js-open-popup-methodology-content]', function (e){
  e.preventDefault()
  openPopup($(this))
})

$body.on('click', '.js-close-popup, .js-background-popup', function (e){
  e.preventDefault()
  closePopup()
})

$(document).keyup(function(e) {
  if (e.key === "Escape" && $popup.is(':visible')) { // escape key maps to keycode `27`
    closePopup()
  }
});
